/**
 * Game-progress mission actions shared by Daily Missions and Career Missions.
 * N is the task's `target_value`.
 */
export const GAME_TASK_ACTIONS = {
  run_connect_level: {
    title: (n) => `Reach Level ${n} in Run Connect`,
    careerMetric: 'level_gte',
    help: 'Progress is the highest level reached that day. Runs do not add up.',
  },
  snapshot_level: {
    title: (n) => `Reach Level ${n} in Snap-Shot`,
    careerMetric: 'level_gte',
    help: 'Progress is the highest level reached that day. Runs do not add up.',
  },
  super_over_win: {
    title: (n) => `Win ${n} Super Over games`,
    careerMetric: 'count',
    help: 'Counts Super Over wins.',
  },
  super_over_win_streak: {
    title: (n) => `Win ${n} Super Over games in a row`,
    careerMetric: 'consecutive_wins',
    help:
      'A loss sets an unfinished task back to 0. The streak only counts Mind Cricket / League Super Overs, not Dugout Daily.',
  },
};

export function isGameTaskAction(actionKey) {
  return Object.prototype.hasOwnProperty.call(GAME_TASK_ACTIONS, actionKey);
}

/** Suggested task title for these actions, or '' for any other action or an unusable N. */
export function gameTaskTitle(actionKey, target) {
  if (!isGameTaskAction(actionKey)) return '';
  const n = Number(target);
  if (!Number.isInteger(n) || n < 1) return '';
  return GAME_TASK_ACTIONS[actionKey].title(n);
}

/** Metric the career editor must use for this action, or '' when the admin may choose. */
export function lockedCareerMetric(actionKey) {
  return isGameTaskAction(actionKey) ? GAME_TASK_ACTIONS[actionKey].careerMetric : '';
}

export function gameTaskHelp(actionKey) {
  return isGameTaskAction(actionKey) ? GAME_TASK_ACTIONS[actionKey].help : '';
}

/**
 * Next title after the action or N changed. The title follows the suggestion
 * unless the admin typed their own (anything other than empty or the previous suggestion).
 */
export function syncGameTaskTitle(currentTitle, prev, next) {
  const typed = String(currentTitle || '').trim();
  const previousSuggestion = gameTaskTitle(prev.action_key, prev.target_value);
  if (typed && typed !== previousSuggestion) return currentTitle;
  return gameTaskTitle(next.action_key, next.target_value);
}
